import { render, staticRenderFns } from "./RadioSet.vue?vue&type=template&id=225bf330&"
import script from "./RadioSet.vue?vue&type=script&lang=ts&"
export * from "./RadioSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports